import React from "react";
import "../css/project.css";

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
    <div className="container">
      <a className="navbar-brand navbar" href="#home" style={{ fontFamily: "Playpen Sans",fontSize:"30px" }}>
        Portfolio
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent" style={{ fontFamily: "Playpen Sans" }} >
        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
          <li className="nav-item mx-4">
            <a className="nav-link" href="#skills">
              Skills
            </a>
          </li>
          <li className="nav-item mx-4">
            <a className="nav-link" href="#experience">
              Experience
            </a>
          </li>
          <li className="nav-item mx-4">
            <a className="nav-link" href="#projects">
              Projects
            </a>
          </li>
          <li className="nav-item mx-4">
            <a className="nav-link" href="#education">
              Education
            </a>
          </li>
        </ul>
        <a
          className="btn btn-outline-secondary"
          type="submit"
          href="https://github.com/Dhananjaywarade"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-github social-icon"></i> GitHub Profile
        </a>
      </div>
    </div>
  </nav>
  );
}

export default Navbar;
